import { createHovercardStore } from "../hovercard/hovercard-store.js";
import { createStore } from "@ariakit/store";
import { defaultValue } from "@ariakit/utils";
//#region src/tooltip/tooltip-store.ts
/**
* Creates a tooltip store.
*/
function createTooltipStore(props = {}) {
	if (process.env.NODE_ENV !== "production") {
		if (props.type === "label") console.warn("The `type` option on the tooltip store is deprecated.", "Render a visually hidden label or use the `aria-label` or `aria-labelledby` attributes on the anchor element instead.", "See https://ariakit.com/components/tooltip#tooltip-anchors-must-have-accessible-names");
	}
	const syncState = props.store?.getState();
	const hovercard = createHovercardStore({
		...props,
		placement: defaultValue(props.placement, syncState?.placement, "top"),
		hideTimeout: defaultValue(props.hideTimeout, syncState?.hideTimeout, 0)
	});
	const tooltip = createStore({
		...hovercard.getState(),
		type: defaultValue(props.type, syncState?.type, "description"),
		skipTimeout: defaultValue(props.skipTimeout, syncState?.skipTimeout, 300)
	}, hovercard, props.store);
	return {
		...hovercard,
		...tooltip
	};
}
//#endregion
export { createTooltipStore };

//# sourceMappingURL=tooltip-store.js.map